import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { RouterModule } from '@angular/router';
import { StepsComponent } from './steps/steps.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { MenuMobileComponent } from './menu-mobile/menu-mobile.component';
import { ButtonComponent } from './button/button.component';
import { ToggleComponent } from './toggle/toggle.component';
import { InputComponent } from './input/input.component';
import { ImagePickerComponent } from './image-picker/image-picker.component';
import { TableComponent } from './table/table.component';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { TranslateModule } from '@ngx-translate/core';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { PhoneInputComponent } from './phone-input/phone-input.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownModule,
    MultiSelectModule,
    TableModule,
    TranslateModule,
    NgxIntlTelInputModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    StepsComponent,
    SidebarComponent,
    MenuMobileComponent,
    ButtonComponent,
    ToggleComponent,
    InputComponent,
    PhoneInputComponent,
    ImagePickerComponent,
    TableComponent,
  ],
  declarations: [
    StepsComponent,
    SidebarComponent,
    MenuMobileComponent,
    ButtonComponent,
    ToggleComponent,
    InputComponent,
    PhoneInputComponent,
    ImagePickerComponent,
    TableComponent,
  ],
  providers: [DatePipe],
})
export class ComponentsModule {}
